const riot = require('riot');

riot.tag2('module-webhook-headers', '<div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4">Header</div> </div> <div class="ts-pxs text-gray_60 mb8">このWebhookを呼び出す際のリクエストヘッダーを追加できます。\\{\\{}}で囲むことで変数が入力できます。</div> <div class="f fb mb8" each="{header, i in headers}"> <div class="w30per flex-fixed mr8"> <div class="f fm mb8"> <div class="ts-hxxs text-gray_80 mr4">Header Name</div> <div class="ts-hxxs text-pink_70">必須</div> </div> <input class="input w-full" ref="name" riot-value="{header.name}" required oninput="{onInput}" pattern="{headerNamePattern}" oninvalid="{onInvalid}" data-message="無効な文字が入っています" disabled="{opts.disabled}"> </div> <div class="w-full mr8"> <div class="ts-hxxs text-gray_80 mb8">Header Value</div> <input class="input w-full mr8" ref="value" riot-value="{header.value}" oninput="{onInput}" disabled="{opts.disabled}"> </div> <button class="button flex-fixed danger size-m" if="{!opts.disabled}" onclick="{onDeleteHeader}" type="button">削除</button> </div> <button class="button size-m" if="{!opts.disabled}" onclick="{onAddHeader}" type="button">Header Fieldの追加</button>', 'module-webhook-headers,[data-is="module-webhook-headers"]{display:block}', '', function(opts) {
    this.headerNamePattern = "[!#$%&'*+\\-.^_`|~A-Za-z0-9]+";

    this.on('mount', () => {

      var headers = this.opts.headers ? this.opts.headers : { '' : '' };
      this.headers = Object.entries(headers).map(([key, value]) => ({'name': key, 'value': value}));
      this.update();
    });

    this.onDeleteHeader = (e) => {
      this.headers.splice(e.item.i , 1);
      this.update();
      this.bubbleTrigger('datachange');
    };

    this.onAddHeader = () => {
      this.headers.push({ name: '' , value: '' });
      this.update();
    };

    this.getValue = () => {
      var value = {};
      this.headers.forEach(h => {
        if (!h.name) return ;
        value[h.name] = h.value;
      });
      return value;
    };

    this.onInput = (e) => {
      var ref = e.currentTarget.getAttribute('ref');
      e.item.header[ref] = e.currentTarget.value;
      e.target.setCustomValidity('');
      this.bubbleTrigger('datachange');
    };

    this.onInvalid = (e) => {

      if (!e.target.value) {
        e.target.setCustomValidity('');
      }

      else if (e.target.dataset.message) {
        e.target.setCustomValidity(e.target.dataset.message);
      }
    };
});